<template>
    <a-row align="center">
        <a-col span="12">
            <b class="paper-font-size">{{show? '作者': title}}</b>
        </a-col>
        <a-col span="12" style="text-align: right">
            <span @click="handle">
                <span v-if="show">
                    <a class="paper-primary-text" v-if="show"> 收起 </a>
                </span>
                <span v-else>
                    <a class="paper-primary-text"><TeamOutlined/>显示全部</a>
                </span>
            </span>
        </a-col>
    </a-row>
    <div>
        <span v-if="text === 'NA'" class="small-font">见文献</span>
        <template v-else>
            <template v-for="(a, k) in data?.slice(0, show? data.length: len)" :key="k">
            <span style="margin-right: 5px">
                <span v-if="a === 'NA'">{{a}}</span>
                <a-tag v-else color="blue" class="paper-primary-text author-tag">{{a}}</a-tag>
            </span>
            </template>
        </template>
        <span v-if="data.length > len" @click="handle">
            <span v-if="!show">
                <a-tag v-if="data.length > 5">...</a-tag>
                <a-tag  v-if="data.length > 5" color="blue" style="margin-right: 5px" class="paper-primary-text author-tag">{{data[data.length - 2]}}</a-tag>
                <a-tag color="blue" style="margin-right: 5px" class="paper-primary-text author-tag">{{data[data.length - 1]}}</a-tag>
            </span>
    </span>
    </div>
    <div style="margin-top: 10px">
        <template v-if="show">
            <b>单位</b>
            <div class="small-font">
                <span v-if="extra === 'NA'">见文献</span>
<!--                <span v-else class="paper-primary-text">{{extra}}</span>-->
                <span v-else style="color: #666">{{extra}}</span>
            </div>
<!--            <template v-for="(a, k) in dataExtra" :key="k">-->
<!--                <span style="margin-right: 5px">-->
<!--                    <span v-if="a === 'NA'">{{a}}</span>-->
<!--                    <span v-else class="paper-primary-text">{{a}}</span>-->
<!--                </span>-->
<!--            </template>-->
        </template>

    </div>

</template>

<script>
    import {TeamOutlined} from '@ant-design/icons-vue';
    export default {
        name: "AuthorOrganization",
        props: ['title', 'text', 'initLen', 'extra', 'extraTitle'],
        components: {TeamOutlined},
        data(){
            return {
                show: false,
                data: [],
                dataExtra: [],
                len: this.initLen || 3
            }
        },
        created(){
            this.text2Arr(this.text);
            this.text2Arr(this.extra, 'Extra');
        },
        watch: {
            text: function(newValue, oldValue){
                if(newValue !== oldValue) this.text2Arr(newValue);
            }
        },
        methods: {
            text2Arr(text, k=''){
                if(typeof text === 'string') this['data' + k] = text.split(',')
            },
            handle(){
                this.show = !this.show;
            }
        }
    }
</script>

<style scoped>
    .author-tag{
        border-radius: 10px;
    }
    .small-font{
        font-size: 14px;
    }
</style>
